/**
 * Suppliers API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { createSupplier, getSupplierById, getSuppliers, updateSupplier } from "../generated/suppliers/suppliers";

import { wrapListMethod, wrapMethod } from "./utils";

export const suppliers = {
  /** @see createSupplier */
  create: wrapMethod(createSupplier),

  /** @see getSuppliers */
  list: wrapListMethod(getSuppliers),

  /** @see getSupplierById */
  get: wrapMethod(getSupplierById),

  /** @see updateSupplier */
  update: wrapMethod(updateSupplier),
} as const;

export type SuppliersApi = typeof suppliers;
